import { Helmet } from "react-helmet-async";

export default function SEO({ title, description }) {
  const fullTitle = title ? `${title} | 3T` : "3T — Wear An Idea, Not Just A Brand";
  const desc = description || "Premium tank tops with bold, motivational messages. Built for those who move with purpose. Free shipping on 3+ items. Australia.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
    </Helmet>
  );
}
